"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submissionRequiredForms = exports.acceptanceRequiredForms = exports.planningFormKey = exports.projectTypeFormKey = void 0;
const types_1 = require("./types");
// The project-type form key for a project type, or null when the type is not
// one of the buildable types (the project-type form requirement then cannot be
// satisfied).
const projectTypeFormKey = (projectType) => {
    switch (projectType) {
        case types_1.ProjectType.VERANDA:
            return 'VERANDA';
        case types_1.ProjectType.PERGOLA:
            return 'PERGOLA';
        case types_1.ProjectType.POOL:
            return 'POOL';
        case 'EXISTING_BUILDING':
            return 'EXISTING_BUILDING';
        default:
            return null;
    }
};
exports.projectTypeFormKey = projectTypeFormKey;
// The planning form key implied by a planning_file_type, or null when none is
// set. Every DP* type uses the DP form; every PC*/PCM* type uses the PC form.
const planningFormKey = (planningFileType) => {
    const pft = planningFileType ?? '';
    if (pft.startsWith('DP'))
        return 'DP';
    if (pft.startsWith('PC') || pft.startsWith('PCM'))
        return 'PC';
    return null;
};
exports.planningFormKey = planningFormKey;
// ── EARLY gate ──────────────────────────────────────────────────────────────
// The forms a salesman/architect addresses *before* a project is accepted or
// its dossier is sent. Intentionally excludes the planning forms (DP/PC/PCM)
// and urban analysis, which are produced after this stage. This is a different
// gate from `submissionRequiredForms` below — the two are deliberately NOT
// merged because they apply at different lifecycle steps.
const acceptanceRequiredForms = (projectType) => [
    'DECLARER',
    'EXISTING_BUILDING',
    'LAND',
    // The raw project type doubles as the project_status key on the frontend.
    projectType,
];
exports.acceptanceRequiredForms = acceptanceRequiredForms;
// Every form that must be VALIDATED before the dossier is submit-ready:
// always LAND + DECLARER, the project-type form, the planning form (DP or PC)
// once a planning type is chosen, and urban analysis once any planning type is
// set.
const submissionRequiredForms = (projectType, planningFileType) => {
    const forms = ['LAND', 'DECLARER'];
    const ptKey = (0, exports.projectTypeFormKey)(projectType);
    if (ptKey !== null)
        forms.push(ptKey);
    const planning = (0, exports.planningFormKey)(planningFileType);
    if (planning !== null)
        forms.push(planning);
    if ((planningFileType ?? '').length > 0)
        forms.push('URBAN_ANALYSIS');
    return { forms, unknownProjectType: ptKey === null };
};
exports.submissionRequiredForms = submissionRequiredForms;
//# sourceMappingURL=form-gating.js.map